import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "field-set-table",
  templateUrl: "./field-set-table.component.html",
  styles: [],
})
export class FieldSetTableComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public recalculateTable() {
    const emptyCol = { components: [] };
    const emtyRow = [];
    while (emtyRow.length < this.fieldOptions.numCols) {
      emtyRow.push(emptyCol);
    }
    while (this.fieldOptions.rows.length < this.fieldOptions.numRows) {
      this.fieldOptions.rows.push(emtyRow);
    }
    while (this.fieldOptions.rows.length > this.fieldOptions.numRows) {
      this.fieldOptions.rows.pop();
    }
    this.fieldOptions.rows.forEach((row) => {
      while (row.length < this.fieldOptions.numCols) {
        row.push(emptyCol);
      }
      while (row.length > this.fieldOptions.numCols) {
        row.pop();
      }
    });
  }

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
